import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";
import { useForm } from "react-hook-form";


import ReactTableBuilder from "../../utils/reactTableBuilder";
import { Box, Divider, IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { MuiButton } from "../../components/mui";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, MuiBox } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';


function MuiStandardForm({children, title, defaultValues, onSubmit = ()=>{}, onSave = ()=>{}, onClose = ()=>{}, dialogProps, ...props}){
    let mainContent = null;
    let footerContent = null;

    React.Children.forEach(children, (child) => {
			if (React.isValidElement(child)) {
				if (child.type === StandardFormMainContent) {
						mainContent = child;
				} else if (child.type === StandardFormFooterContent) {
					footerContent = child;
				}
			}
    });

    return (
			<Dialog open={props.isOpen} onClose={props.onClose} {...dialogProps} disableEnforceFocus>
				<DialogTitle>{title}</DialogTitle>
				<form onSubmit={onSubmit}>			
					<DialogContent>
							{mainContent}
					</DialogContent>
					<DialogActions>
						{ footerContent ? footerContent :
						(<>
							<MuiButton color="primary" variant="outlined" onClick={onClose}>{t("cancel")}</MuiButton>
							<MuiButton type="submit" color="primary">{t("save")}</MuiButton>
						</>)
					}
					</DialogActions>
				</form>
			</Dialog>
    )
}

export const StandardFormMainContent = ({ children }) => <>{children}</>;
export const StandardFormFooterContent = ({ children }) => <>{children}</>;

MuiStandardForm.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(MuiStandardForm);